/** Canonical frontend paths for the staff-only Super configuration hub. */
export const SUPER_PATHS = {
  root: "/super",
  accounts: "/super/accounts",
  accountBilling: "/super/accounts/:accountId/billing",
  selfOnboarding: "/super/onboarding",
  partners: "/super/partners",
  quotes: "/super/quotes",
  quote: "/super/quotes/:quoteId",
  quoteCreateCompany: "/super/quotes/:quoteId/create-company",
  onboardingCalendar: "/super/onboarding-calendar",
  playbooks: "/super/playbooks",
  companyExpansion: "/super/company/expansion",
  companyLegacyVoiceControls: "/super/company/legacy-voice-controls",
  companyVoiceAiProvider: "/super/company/voice-ai-provider",
  companySensitiveControls: "/super/company/sensitive-controls",
  companyInDevelopment: "/super/company/in-development",
  companyInternalConnections: "/super/company/internal-connections",
  insights: "/super/insights",
  industryInsights: "/super/industry-insights",
  marketingWebsite: "/super/marketing-website",
  manageSettings: "/super/manage-settings",
  manageSettingsTab: "/super/manage-settings/:settingPath",
  reportEmailPreview: "/super/report-email-preview",
  monitoring: "/super/monitoring",
  defaultAgents: "/super/operator/agents",
  managedRoutines: "/super/operator/routines",
  portOrders: "/super/phone/port-orders",
  semanticSearch: "/super/semantic-search",
  dispositionBackfill: "/super/disposition-backfill",
  demoIdentities: "/super/demo-identities",
  // Global agent-config templates. Surfaced to supers as "default configs" —
  // the noun the Agent logic tab uses when one is applied — while the code and
  // dale's routes keep the `template` noun.
  agentTemplates: "/super/agent-templates",
  agentTemplate: "/super/agent-templates/:agentId",
} as const;

export const superAccountBillingPath = (accountId: string): string =>
  `${SUPER_PATHS.accounts}/${accountId}/billing`;

export const superQuotePath = (quoteId: string): string =>
  `${SUPER_PATHS.quotes}/${encodeURIComponent(quoteId)}`;

export const superQuoteCreateCompanyPath = (quoteId: string): string =>
  `${superQuotePath(quoteId)}/create-company`;

export const superAgentTemplatePath = (agentId: string): string =>
  `${SUPER_PATHS.agentTemplates}/${agentId}`;
